import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { TokenStorageService } from '@auth/services/token-storage.service';
import { UserContextService } from '../services/user-context.service';

export const notConnectedGuard: CanActivateFn = async (route, state) => {
  const tokenStorage = inject(TokenStorageService);
  const userContext = inject(UserContextService);

  const token = await tokenStorage.getToken();

  if (token) {
    await tokenStorage.removeToken();
    userContext.clear();
  }

  return true;
};
